import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const d = (i) => ({ transitionDelay: `${(i * 0.07).toFixed(2)}s` });

export default function LetterPanel() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email, source: "thursday_edit" });
      toast.success(data.message || "You're on the list!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="panel sec-letter" id="letter" data-testid="panel-letter">
      <div className="letter-inner">
        <div className="sec-eyebrow on-dark reveal" style={d(0)}>The Thursday Edit</div>
        <h2 className="letter-h reveal" style={d(1)}>
          A thoughtful note for the life <em>you're designing.</em>
        </h2>
        <p className="letter-sub reveal" style={d(2)}>
          Every Thursday, I'll send honest reflections on motherhood and intentional living,
          favorite home and style finds, and one small idea to make everyday life feel a little
          more beautiful.
        </p>
        <form className="letter-form reveal" style={d(3)} data-testid="newsletter-form" onSubmit={submit}>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            aria-label="Email address"
            data-testid="newsletter-email-input"
          />
          <button type="submit" disabled={loading} data-testid="newsletter-submit-button">
            {loading ? "Joining…" : "Join"}
          </button>
        </form>
        <p className="letter-fine reveal" style={d(4)}>No spam, ever. Unsubscribe anytime.</p>
      </div>
    </section>
  );
}
